import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/login/login.js';
import Home from './pages/home/home.js';
import ProtectedRoute from './pages/protectedRoute/protectedRoute.js';
import { LoginProvider } from './context/loginContext.js';
import { MovimientosProvider } from './context/movimientosContext.js';
import MainLayout from './pages/layout/layout.js';
import CUsuarios from './pages/usuarios/usuarios.js';
import CMarcas from './pages/marcas/marcas.js';
import CCategorias from './pages/categorias/categorias.js';
import CArticulos from './pages/articulos/articulo.js';
import CEntrada from './pages/movimientos/entrada.js';
import CPosiciones from './pages/posiciones/posiciones.js';
import CPosicionesArticulo from './pages/posiciones/posicionesarticulo.js';
import CHistorial from './pages/historial/historial.js';
import CEntradaXArticulo from './pages/entrada/entradaXArticulo.js';
import CSalidaXArticulo from './pages/salida/salidaXArticulo.js';
import CInicioCliente from './pages/cliente/home-cliente.js';
import CPosicionCliente from './pages/cliente/posicion-cliente.js';
import CSalidaCliente from './pages/cliente/retiro-cliente.js';
import CPedidosCliente from './pages/cliente/pedidos-cliente.js';
import CPedidos from './pages/pedidos/pedidos.js';
import CHistorialCliente from './pages/cliente/historial-cliente.js';

function App() {
  return (
    <LoginProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Protegemos todas las rutas */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Home />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/usuarios"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CUsuarios allowedRoles={['administrador']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/marcas"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CMarcas allowedRoles={['administrador']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/categorias"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CCategorias allowedRoles={['administrador']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/articulos"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CArticulos allowedRoles={['administrador']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/entrada"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CEntrada allowedRoles={['administrador']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/entradaxarticulo"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <MovimientosProvider>
                    <CEntradaXArticulo allowedRoles={['administrador']} />
                  </MovimientosProvider>
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/posiciones"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CPosiciones allowedRoles={['administrador']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/posicionesarticulo"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CPosicionesArticulo allowedRoles={['administrador']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/salida"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <MovimientosProvider>
                    <CSalidaXArticulo allowedRoles={['administrador']} />
                  </MovimientosProvider>
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/historial"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CHistorial allowedRoles={['administrador']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/pedidos"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CPedidos allowedRoles={['administrador']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/home-cliente"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CInicioCliente allowedRoles={['cliente']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/posicion-cliente"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CPosicionCliente allowedRoles={['cliente']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/retiro-cliente"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CSalidaCliente allowedRoles={['cliente']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/pedidos-cliente"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CPedidosCliente allowedRoles={['cliente']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/historial-cliente"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <CHistorialCliente allowedRoles={['cliente']} />
                </MainLayout>
              </ProtectedRoute>
            }
          />
        </Routes>

      </Router>
    </LoginProvider>
  );
}

export default App;
